export const RENT_TEXTS = {
  info: `Будьте в курсе арендной ставки вашей недвижимости, чтобы не упустить момент для выгодной сделки.`,
  btnText: `Узнать арендную ставку`,
};

export const SALE_TEXTS = {
  info: `Будьте в курсе, сколько стоит ваша недвижимость, чтобы не упустить момент для выгодной сделки.`,
  btnText: `Узнать стоимость`,
};
